module.exports = __webpack_public_path__ + "static/CLAN_mobile-78c456e913a9b6cb89876d5a7a18c9f2.mp4";